import React, { Component } from "react";
import "./RatingTable.css";
import Table from "antd/lib/table";
import Rate from "antd/lib/rate";
import Button from "antd/lib/button";
import "antd/lib/table/style/css";
import "antd/lib/rate/style/css";
import "react-tippy/dist/tippy.css";
import axios from "axios";
import logo from "../assets/loading.gif";
import { Tooltip } from "react-tippy";

class RatingTable extends Component {
  state = {
    loaded: false,
    data: [],
    anoExercicio: ""
  };

  componentWillMount() {
    const anoAtual = this.getAnoAtual();

    this.setState({
      anoExercicio: anoAtual
    });
  }

  getAnoAtual = () => {
    return new Date().getFullYear().toString();
  };

  componentDidMount() {
    const config = {
      headers: { "Isis-token": "2a19eb559b3d4ab0b80e46fc894532aa" }
    };

    axios
      .get(
        "https://appcodata.pb.gov.br/isis-api/api/v1/sgp/avaliacoesorgaos?ano=" +
          this.state.anoExercicio,
        config
      )
      .then(res =>
        this.setState({
          data: res.data.result.data,
          loaded: true
        })
      )
      .catch(err => console.log(err));
  }

  changeYear = evt => {
    const config = {
      headers: { "Isis-token": "2a19eb559b3d4ab0b80e46fc894532aa" }
    };

    this.setState({ anoExercicio: evt.target.value });

    axios
      .get(
        "https://appcodata.pb.gov.br/isis-api/api/v1/sgp/avaliacoesorgaos?ano=" +
          evt.target.value,
        config
      )
      .then(res =>
        this.setState({
          data: res.data.result.data,
          loaded: true
        })
      )
      .catch(err => console.log(err));
  };

  printPage = evt => {
    evt.preventDefault();
    window.print();
  };

  render() {

    console.log(this.state.data)
    const currentYear = this.getAnoAtual();
    let startYear = 2018; //ano de início do feedback sic
    const years = [];
    while (startYear <= currentYear) {
      years.push(startYear++);
    }

    const { loaded, data } = this.state;
    const columns = [
      {
        title: "Órgão",
        dataIndex: "orgao",
        key: "orgao",
        render: (text, record) => (
          <Tooltip
            title={record.nm_descricao}
            size="small"
            animation="none"
            delay="300"
          >
            <span>{record.orgao}</span>
          </Tooltip>
        )
      },
      {
        title: "",
        dataIndex: "MEDIA",
        key: "media",
        render: (text, record) => (
          <span key={record.cd_setor} className="star-table-span">
            <Rate
              disabled
              defaultValue={record.media}
              key={record.cd_setor}
              className="star-display"
            />
            <Rate
              disabled
              defaultValue={record.media}
              key={record.cd_setor}
              className="star-printer"
              style={{ color: "black" }}
            />
          </span>
        ),
        align: "right"
      },
      {
        title: "Média das Avaliações",
        dataIndex: "media",
        key: "media",
        align: "center"
      },
      {
        title: "Quantidade de Avaliações",
        dataIndex: "qde_avaliacoes",
        key: "qde_avaliacoes",
        align: "center"
      }
    ];

    return (
      <div className="rating-table">
        <form>
          <div className="form-group year-select">
            <span>Exercício:&nbsp;</span>
            &nbsp;
            <select
              className="form-control-sm year-button"
              id="selectAnoExercicio"
              onChange={this.changeYear}
              value={this.state.anoExercicio}
            >
              {years.map(year => (
                <option value={year} key={year}>
                  {year}
                </option>
              ))}
            </select>
            &nbsp;
            <Button
              icon="printer"
              onClick={this.printPage}
              className="no-print"
            >
              <span className="button-label">Impressão</span>
            </Button>
          </div>
        </form>
        {loaded ? (
          <Table
            dataSource={data}
            columns={columns}
            pagination={false}
            size={"small"}
          />
        ) : (
          <img src={logo} className='loading-image' alt="carregando..." />
        )}
      </div>
    );
  }
}

export default RatingTable;



// WEBPACK FOOTER //
// /src/RatingTable/RatingTable.js